/** es — Spanish stub. See pt-BR for rationale on partial coverage. */
import type enUS from "./en-US";
type EnResources = typeof enUS;
type DeepPartial<T> = { [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K] };

const es: DeepPartial<EnResources> = {
  nav: {
    dashboard: "Panel",
    people: "Personas",
    timeOff: "Ausencias",
    timeTracking: "Registro horario",
    invoices: "Facturas",
    approvals: "Aprobaciones",
    recruiting: "Reclutamiento",
    performance: "Desempeño",
    assets: "Activos",
    complaints: "Quejas",
    documents: "Documentos",
    reports: "Informes",
    aiAssistant: "Asistente IA",
    settings: "Ajustes",
    primary: "Principal",
    expandSidebar: "Expandir menú",
    collapseSidebar: "Contraer menú",
    securityMfa: "Seguridad y MFA",
    logout: "Cerrar sesión",
  },
  common: {
    loading: "Cargando…",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    close: "Cerrar",
    search: "Buscar",
    language: "Idioma",
    timezone: "Zona horaria",
    currency: "Moneda",
    accessDenied: "Acceso denegado",
    accessDeniedBody: "No tienes permiso para ver esta página.",
    retry: "Reintentar",
    noResults: "Sin resultados",
  },
  auth: {
    welcomeBack: "Bienvenido de nuevo",
    signInSubtitle: "Inicia sesión en tu cuenta",
    tagline:
      "La plataforma de RR. HH. inteligente que tu equipo realmente quiere usar. Gestiona personas, tiempo y cultura — todo en un solo lugar.",
    demoHint: "Demo: admin@acme.com / demo1234",
    signIn: "Iniciar sesión",
    email: "Correo",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    rememberMe: "Recuérdame",
  },
  notifications: {
    title: "Notificaciones",
    markAllRead: "Marcar todas como leídas",
    empty: "Aún no hay notificaciones.",
    justNow: "ahora mismo",
    minutesAgo: "hace {{count}}m",
    hoursAgo: "hace {{count}}h",
    daysAgo: "hace {{count}}d",
    unreadCountLabel: "Notificaciones, {{count}} sin leer",
    unreadPrefix: "Sin leer: {{title}}",
  },
  search: {
    placeholder: "Buscar personas, documentos, tareas…",
    groups: {
      pages: "Páginas",
      people: "Personas",
      documents: "Documentos",
      tasks: "Tareas",
    },
  },
  settings: {
    preferences: "Preferencias",
    preferencesHint:
      "Idioma, zona horaria y moneda utilizados en toda la aplicación.",
    languageLabel: "Idioma",
    timezoneLabel: "Zona horaria",
    currencyLabel: "Moneda de visualización",
  },
};

export default es;
